export default __webpack_public_path__ + "static/media/createlink.40d66e07.svg";